import { isNil, head, is } from 'ramda';
import { camelize } from './keysConverter';

export const getServerError = error => {
  const {
    response: {
      data: { errors },
    },
  } = error;

  if (is(String, errors)) {
    return errors.replace('["', '').replace('"]', '');
  }

  return head(errors);
};

export const apiErrorsToFormik = error => {
  const { errors } = error.response.data;
  if (is(String, errors)) return { fullMessages: getServerError(error) };
  if (isNil(errors)) return {};
  const camelizedErrors = camelize(errors);
  return Object.keys(camelizedErrors).reduce((acc, key) => ({ ...acc, [key]: camelizedErrors[key].join(', ') }), {});
};

export const getServerErrorsFullMessages = error => {
  const { errors } = error.response.data;
  if (is(String, errors)) return { fullErrorMessages: getServerError(error) };
  if (isNil(errors)) return {};

  if (is(Array, errors) || is(Object, errors)) {
    const camelizedErrors = is(Array, errors) ? camelize(head(errors)) : camelize(errors);
    const fullErrorMessages = Object.keys(camelizedErrors).reduce(
      (acc, key) =>
        `${acc} ${key}: ${camelizedErrors[key]
          .join(', ')
          .replace('["', '')
          .replace('"]', '')}`,
      '',
    );
    return { fullErrorMessages };
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/utils/errors.js